import { makeAssistantToolUI } from '@assistant-ui/react';
import { NotebookPen } from 'lucide-react';

export const UpdateWorkingMemoryToolUI = makeAssistantToolUI<{}, {}>({
    toolName: 'updateWorkingMemory',
    render: ({ args, result }) => null,
});
